import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrarElev from "../../Components/OrarElev";
import { getDataDoc } from "../../database";
import withErrorBoundary from "../../Components/withErrorComponent";
function Orar() {
  const user = useSelector((state) => state.user);
  const [classData, setClassData] = useState(null);

  const fetch = async () => {
    let clas = await getDataDoc("claseData", user.clasa);
    
    // Obținem și datele elevului pentru orele particulare
    let elevData = await getDataDoc("elevi", user.uid);
    
    // Combinăm orele clasei cu orele particulare ale elevului
    let oreClasa = clas?.ore?.map((el) => {
      return {
        ...el,
        startDate: new Date(el.startDate),
        endDate: new Date(el.endDate),
      };
    }) || [];
    
    let oreParticulare = elevData?.orePrivat?.map((el) => {
      return {
        ...el,
        startDate: new Date(el.startDate),
        endDate: new Date(el.endDate),
      };
    }) || [];

    setClassData({
      ...clas,
      ore: [...oreClasa, ...oreParticulare],
    });
  };
  useEffect(() => {
    fetch();
  }, [user]);
  return classData && <OrarElev classData={classData} />;
}

export default withErrorBoundary(Orar);
